/** Local calendar dates: keep the original day-of-month, then move weekends forward. */
export function nextMondayIfWeekend(date: Date): Date {
  const result = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  if (result.getDay() === 6) result.setDate(result.getDate() + 2);
  else if (result.getDay() === 0) result.setDate(result.getDate() + 1);
  return result;
}

export function monthlyInstallmentDates(first: Date | null, count: number): (Date | null)[] {
  if (!first || Number.isNaN(first.getTime())) return Array.from({ length: count }, () => null);
  return Array.from({ length: count }, (_, index) => {
    const month = new Date(first.getFullYear(), first.getMonth() + index, 1);
    const lastDay = new Date(month.getFullYear(), month.getMonth() + 1, 0).getDate();
    return nextMondayIfWeekend(new Date(month.getFullYear(), month.getMonth(), Math.min(first.getDate(), lastDay)));
  });
}
